__turbopack_context__.v({
  "checkIcon": "OfficeHoursFormField-module-scss-module__HUvcUW__checkIcon",
  "description": "OfficeHoursFormField-module-scss-module__HUvcUW__description",
  "error": "OfficeHoursFormField-module-scss-module__HUvcUW__error",
  "errorMessage": "OfficeHoursFormField-module-scss-module__HUvcUW__errorMessage",
  "input": "OfficeHoursFormField-module-scss-module__HUvcUW__input",
  "inputWrapper": "OfficeHoursFormField-module-scss-module__HUvcUW__inputWrapper",
  "invalid": "OfficeHoursFormField-module-scss-module__HUvcUW__invalid",
  "invalidText": "OfficeHoursFormField-module-scss-module__HUvcUW__invalidText",
  "label": "OfficeHoursFormField-module-scss-module__HUvcUW__label",
  "labelWrapper": "OfficeHoursFormField-module-scss-module__HUvcUW__labelWrapper",
  "loader": "OfficeHoursFormField-module-scss-module__HUvcUW__loader",
  "prixClipFix": "OfficeHoursFormField-module-scss-module__HUvcUW__prixClipFix",
  "root": "OfficeHoursFormField-module-scss-module__HUvcUW__root",
  "rotate": "OfficeHoursFormField-module-scss-module__HUvcUW__rotate",
  "successMessage": "OfficeHoursFormField-module-scss-module__HUvcUW__successMessage",
  "valid": "OfficeHoursFormField-module-scss-module__HUvcUW__valid",
  "validText": "OfficeHoursFormField-module-scss-module__HUvcUW__validText",
  "validating": "OfficeHoursFormField-module-scss-module__HUvcUW__validating",
  "validatingText": "OfficeHoursFormField-module-scss-module__HUvcUW__validatingText",
  "validationStatus": "OfficeHoursFormField-module-scss-module__HUvcUW__validationStatus",
});
